import { useSelector } from "react-redux";
import { RootState } from "../common/commonTypes";

export const useLoggedInUser = () =>
  useSelector((state: RootState) => {
    return state.auth.user;
});